/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Upgrade_DescInputs */

const en_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Track your application performance, response rates, and resume effectiveness with detailed analytics.`)
};

const de_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verfolge deine Bewerbungsleistung, Antwortquoten und Lebenslauf-Effektivität mit detaillierten Analysen.`)
};

const fr_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suis la performance de tes candidatures, les taux de réponse et l'efficacité de tes CV avec des analyses détaillées.`)
};

const es_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haga seguimiento del rendimiento de sus solicitudes, tasas de respuesta y efectividad de currículum con análisis detallados.`)
};

const it_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monitora le prestazioni delle tue candidature, i tassi di risposta e l'efficacia del curriculum con analisi dettagliate.`)
};

const nl_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg je sollicitatieprestaties, responspercentages en CV-effectiviteit met gedetailleerde analyses.`)
};

const pl_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Śledź skuteczność swoich aplikacji, wskaźniki odpowiedzi i efektywność CV dzięki szczegółowym analizom.`)
};

const fi_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seuraa hakemustesi suorituskykyä, vastausprosentteja ja ansioluettelon tehokkuutta yksityiskohtaisella analytiikalla.`)
};

const da_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Følg din ansøgningsperformance, svarprocenter og CV-effektivitet med detaljerede analyser.`)
};

const sv_analytics_upgrade_desc = /** @type {(inputs: Analytics_Upgrade_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Följ din ansökningsprestanda, svarsfrekvenser och CV-effektivitet med detaljerade analyser.`)
};

/**
* | output |
* | --- |
* | "Track your application performance, response rates, and resume effectiveness with detailed analytics." |
*
* @param {Analytics_Upgrade_DescInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_upgrade_desc = /** @type {((inputs?: Analytics_Upgrade_DescInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Upgrade_DescInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_upgrade_desc(inputs)
	if (locale === "fr") return fr_analytics_upgrade_desc(inputs)
	if (locale === "es") return es_analytics_upgrade_desc(inputs)
	if (locale === "it") return it_analytics_upgrade_desc(inputs)
	if (locale === "nl") return nl_analytics_upgrade_desc(inputs)
	if (locale === "pl") return pl_analytics_upgrade_desc(inputs)
	if (locale === "fi") return fi_analytics_upgrade_desc(inputs)
	if (locale === "da") return da_analytics_upgrade_desc(inputs)
	if (locale === "sv") return sv_analytics_upgrade_desc(inputs)
	return en_analytics_upgrade_desc(inputs)
});